import { replaceTo } from 'modules/auth/actions/redirectAction';
import { fetchServices } from 'modules/common/actions/fetchServices';
import { askPermission } from 'modules/common/actions/askPermission';
import { onRestore } from 'modules/conference/actions/offlineHandlers';
import { createFirebase } from 'modules/notifications/actions/createFirebase';
import { askLogoutWithSelectedOrganization } from 'modules/auth/actions/logout';
import { startObserveAuthUpdates } from 'modules/websocket/actions/authUpdates';
import { startObserveUserUpdates } from 'modules/websocket/actions/userUpdates';
import { showAppointmentInfo } from 'modules/queues/common/actions/appointmentInfo';
import { fetchAppointments } from 'modules/queues/Schedule/actions/fetchAppointments';
import { fetchAllowedContractsCount } from 'modules/queues/common/actions/appointmentForm';
import { CLOSED_APPOINTMENT_STATUSES } from 'modules/common/constants/appointmentStatuses';
import { fetchAppointmentById } from 'modules/queues/Schedule/actions/fetchAppointmentById';
import { startObserveConversationUpdate } from 'modules/websocket/actions/conversationUpdate';
import { startAvailabilityPing } from 'modules/serviceWorker/actions/startStopAvailabilityPing';
import { startObserveAppointmentsUpdates } from 'modules/websocket/actions/appointmentsUpdates';
import { checkActiveConversation } from 'modules/conference/actions/_newConversationActions/checkActiveConversation';
import { fetchTimeoutPing } from './fetchTimeoutPing';
import { CHECK_CLOSEST_APPOINTMENT, checkClosestAppointment } from './closestAppointment';

export const onConferencePageMount = (location, history) => (dispatch, getState) => {
  const state = getState();
  const { selectedOrganizationToken } = state.auth.organizations;
  const myUserId = state.auth.userInfo.userId;

  const params = new URLSearchParams(location.search);
  const URLAppointmentId = params.get('appointmentId');
  const URLOrganizationId = Number(params.get('orgId'));

  dispatch(fetchTimeoutPing())
    .then(({ payload: { updateAvailabilityCheckIntervalInSec = 5 } }) => dispatch(startAvailabilityPing(updateAvailabilityCheckIntervalInSec * 1000)));

  dispatch(askPermission());

  dispatch(startObserveAppointmentsUpdates());
  dispatch(startObserveAuthUpdates());
  dispatch(startObserveConversationUpdate());
  dispatch(startObserveUserUpdates([myUserId]));

  dispatch(fetchAppointments())
    .then(() => dispatch(checkActiveConversation(location, history)));
  dispatch(fetchServices());
  dispatch(fetchAllowedContractsCount());
  if (Notification.permission === 'granted') dispatch(createFirebase());
  dispatch(onRestore());

  if (URLAppointmentId) {
    if (selectedOrganizationToken === URLOrganizationId) {
      dispatch(fetchAppointmentById(URLAppointmentId))
        .then(({ appointment }) => {
          const { hideArchive } = state.common.organizationConfig.appointmentConfig;
          if (appointment && (!CLOSED_APPOINTMENT_STATUSES.includes(appointment.status) || !hideArchive)) {
            dispatch(showAppointmentInfo(appointment.appointmentId));
          } else {
            dispatch(checkClosestAppointment(location.search, true));
          }
        })
        .catch(err => console.log(err))
        .finally(() => replaceTo('/appointments'));
    } else {
      dispatch(askLogoutWithSelectedOrganization());
    }
  }
};


export const onExternalConferencePageMount = () => (dispatch, getState) => {
  const state = getState();
  const myUserId = state.auth.userInfo.userId;

  dispatch({ type: CHECK_CLOSEST_APPOINTMENT.success });
  dispatch(startObserveAppointmentsUpdates());
  dispatch(startObserveConversationUpdate());
  dispatch(startObserveUserUpdates([myUserId]));

  dispatch(checkActiveConversation());
};
